import { useState } from 'react';

import useResizeObserver from './useResizeObserver';

const useIsTruncated = <T extends HTMLElement = HTMLDivElement>() => {
  const [isTruncated, setIsTruncated] = useState(false);

  const checkIfTruncated = (target: T) => {
    setIsTruncated(target.scrollWidth > target.clientWidth);
  };

  const targetRef = useResizeObserver<T>({
    onMount: checkIfTruncated,
    onResize: checkIfTruncated,
  });

  return { isTruncated, ref: targetRef };
};

export default useIsTruncated;
